import { createReducer, on } from '@ngrx/store';
import { ViewedIdentityCard } from '../../../models/document.model';
import { identityCardActions } from './identity_card.actions';

export interface IdentityCardViewState {
    data: ViewedIdentityCard | null;
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: IdentityCardViewState = {
    data: null,
    state: 'pending',
};

export const identityCardReducer = createReducer(
    initialState,
    on(identityCardActions.loadViewSuccess, (state, { payload }) => ({ ...state, data: payload, state: 'loaded' as const })),
    on(identityCardActions.loadExtractionInfoSuccess, (state, { payload }) => ({ ...state, data: payload, state: 'loaded' as const })),
    on(identityCardActions.clearView, () => initialState),
    on(identityCardActions.editExtractionSuccess, (state, { payload }) => ({
        ...state,
        data: state.data ? { ...state.data, extracted_card: payload } : state.data,
    }))
);
